module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-b10514ddcd6c0e66b38b11d517233744.svg";